import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import NewsletterSubscribe from './NewsletterSubscribe';

const Footer: React.FC = () => {
  const { theme } = useTheme();

  return (
    <footer className="bg-background border-t">
      <div className="container mx-auto px-4 py-8">
        {/* Newsletter Subscription */}
        <div className="mb-12">
          <div className="max-w-xl mx-auto">
            <NewsletterSubscribe />
          </div>
        </div>

        {/* Add Contact Sales Button */}
        <div className="mb-12 text-center">
          <Button
            size="lg"
            variant="outline"
            onClick={() => window.location.href = '/contact'}
          >
            Contact Sales
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>

        <div className="border-t pt-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-2 mb-4 group">
                <div className="relative">
                  <img
                    src={theme === 'dark' ? '/babb-logo-dark.svg' : '/babb-logo-light.svg'}
                    alt="Babbage Logo"
                    className="h-8 w-8 relative transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 drop-shadow-sm"
                  />
                </div>
                <h3 className="text-lg font-[500] tracking-tight">
                  Babbage
                </h3>
              </div>
              <p className="text-muted-foreground">
                Building an ecosystem for privacy-respecting, human-centric applications and services.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-muted-foreground hover:text-primary">Home</Link></li>
                <li><Link to="/about" className="text-muted-foreground hover:text-primary">About</Link></li>
                <li><Link to="/contact" className="text-muted-foreground hover:text-primary">Contact</Link></li>
              </ul>
            </div>

            {/* Products */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Products</h3>
              <ul className="space-y-2">
                <li><a href="https://bitcoin-sv.github.io/metanet-desktop" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary">Metanet Desktop</a></li>
                <li><Link to="/overlay-hosting-services" className="text-muted-foreground hover:text-primary">Overlay Hosting Services</Link></li>
                <li><Link to="/wallet-storage-management" className="text-muted-foreground hover:text-primary">Wallet Storage & Management</Link></li>
                <li><Link to="/chain-backed-storage-services" className="text-muted-foreground hover:text-primary">Chain Backed Storage</Link></li>
                <li><Link to="/identity-verification-services" className="text-muted-foreground hover:text-primary">Identity Verification</Link></li>
              </ul>
            </div>

            {/* Solutions */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Solutions</h3>
              <ul className="space-y-2">
                <li><Link to="/blockchain-training-enterprise-engineers" className="text-muted-foreground hover:text-primary">Blockchain Training</Link></li>
                <li><Link to="/financial-trading-tokenization" className="text-muted-foreground hover:text-primary">Financial & Tokenization</Link></li>
                <li><Link to="/archival-recordkeeping" className="text-muted-foreground hover:text-primary">Archival & Recordkeeping</Link></li>
                <li><Link to="/provenance" className="text-muted-foreground hover:text-primary">Provenance</Link></li>
                <li><Link to="/api-platform-monetization" className="text-muted-foreground hover:text-primary">API Monetization</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Babbage. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;